/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMemberInviteDto } from '../../models/backend-member-invite-dto';
import { BackendMemberInviteRequestDto } from '../../models/backend-member-invite-request-dto';

export interface AccessProjectsMembersInviteCreate$FormData$Params {
  project_id: number;
  body: BackendMemberInviteRequestDto;
}

export function accessProjectsMembersInviteCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: AccessProjectsMembersInviteCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMemberInviteDto>> {
  const rb = new RequestBuilder(rootUrl, accessProjectsMembersInviteCreate$FormData.PATH, 'post');
  if (params) {
    rb.path('project_id', params.project_id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMemberInviteDto>;
    }),
  );
}

accessProjectsMembersInviteCreate$FormData.PATH = '/api/access/projects/{project_id}/members/invite/';
